import classNames from 'classnames';
import React from 'react';
import MagneticWallItemAvatar from '../MagneticWallItemAvatar';
import Emoji from './Emoji';
import * as styles from './ReactionAvatar.module.scss';
import Tooltip from '../../components/Tooltip';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const REACTION_FRAGMENT = gql(`
  fragment ReactionAvatar_reaction on ReactionFields {
    id
    author {
      id
      ...MagneticWallItemAvatar_user
    }
    emoji
  }
`);

interface ReactionAvatarProps {
  reaction: DocumentType<typeof REACTION_FRAGMENT>;
  active?: boolean;
  highlighted?: boolean;
  withinOverlay?: boolean;
  tooltip?: React.ReactNode;
}

const ReactionAvatar = ({
  reaction,
  active,
  withinOverlay,
  highlighted,
  tooltip,
}: ReactionAvatarProps) => {
  return (
    <div
      className={classNames(styles.container, {
        [styles.isWithinOverlay]: withinOverlay,
      })}
    >
      <div className={styles.avatar}>
        <MagneticWallItemAvatar user={reaction.author} />
      </div>
      <span
        className={classNames(styles.emoji, {
          [styles.isActive]: active,
          [styles.isHighlighted]: highlighted,
        })}
      >
        <Tooltip content={tooltip}>
          <Emoji char={reaction.emoji} size="small" />
        </Tooltip>
      </span>
    </div>
  );
};

export default ReactionAvatar;
